'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
const defaults = {
  id: null,
  collectionId: null,
  type: null,
  internalName: '',
  name: '',
  tagline: '',
  title: '',
  description: '',
  slug: '',
  htmlPageTitle: '',
  metaDescription: '',
  displayed: true,
  canonicalUrl: '',
  canonicalCollectionId: null,
  canonicalCategory: null,
  canonicalSuperCategory: null,
  updatedAt: 0,
  updatedBy: '',
  query: Immutable.fromJS({
    andFilters: [],
    sortField: null,
    staticItemIds: [],
    limit: null
  }),
  filters: Immutable.fromJS({
    andFilters: []
  })
};
export default class CollectionListing extends Immutable.Record(defaults) {
  static from(data) {
    return new CollectionListing(data);
  }

  toCleanedJS() {
    const listingObject = this.toJS();
    const listingFilters = this.get('filters');
    const cleanedFilters = listingFilters.hasValidFilters() ? cleanObject(listingFilters.toJS(), val => !val) : null;
    return cleanObject(Object.assign({}, listingObject, {
      filters: cleanedFilters
    }));
  }

}